import { useState, useEffect } from 'react';
import '../styles/AdminProveedores.css';

const CAMPOS_FORM = [
  { key: 'nombre',           label: 'Nombre',             placeholder: 'Muebles Rodríguez S.A.',  required: true },
  { key: 'contacto',         label: 'Persona de contacto', placeholder: 'Juan Rodríguez' },
  { key: 'telefono',         label: 'Teléfono',            placeholder: '+54 9 11 1234-5678' },
  { key: 'email',            label: 'Email',               placeholder: 'ventas@proveedor.com', type: 'email' },
  { key: 'condiciones_pago', label: 'Condiciones de pago', placeholder: '30 días / contado con 10% dto.' },
  { key: 'notas',            label: 'Notas',               placeholder: 'Info adicional…', multiline: true },
];

const FORM_VACIO = { nombre: '', contacto: '', telefono: '', email: '', condiciones_pago: '', notas: '' };

export default function AdminProveedores({ isOpen, onClose }) {
  const [proveedores, setProveedores] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [vista, setVista] = useState('lista'); // 'lista' | 'form' | 'detalle'
  const [editando, setEditando] = useState(null); // proveedor objeto o null (nuevo)
  const [form, setForm] = useState(FORM_VACIO);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [detalle, setDetalle] = useState(null); // proveedor seleccionado
  const [productos, setProductos] = useState([]);
  const [cargandoProds, setCargandoProds] = useState(false);
  const [confirmandoEliminar, setConfirmandoEliminar] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    cargarProveedores();
  }, [isOpen]);

  const cargarProveedores = () => {
    setCargando(true);
    fetch('/api/proveedores')
      .then(r => r.json())
      .then(data => setProveedores(data))
      .catch(() => {})
      .finally(() => setCargando(false));
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm(FORM_VACIO);
    setError('');
    setOk('');
    setVista('form');
  };

  const abrirEditar = (prov) => {
    setEditando(prov);
    setForm({
      nombre:           prov.nombre || '',
      contacto:         prov.contacto || '',
      telefono:         prov.telefono || '',
      email:            prov.email || '',
      condiciones_pago: prov.condiciones_pago || '',
      notas:            prov.notas || '',
    });
    setError('');
    setOk('');
    setVista('form');
  };

  const abrirDetalle = (prov) => {
    setDetalle(prov);
    setVista('detalle');
    setCargandoProds(true);
    fetch(`/api/proveedores/${prov._id}/productos`)
      .then(r => r.json())
      .then(data => setProductos(data))
      .catch(() => setProductos([]))
      .finally(() => setCargandoProds(false));
  };

  const volver = () => {
    setVista('lista');
    setDetalle(null);
    setProductos([]);
    setEditando(null);
    setError('');
    setOk('');
  };

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const guardar = async () => {
    if (!form.nombre.trim()) { setError('El nombre es obligatorio.'); return; }
    setGuardando(true);
    setError('');
    try {
      const url    = editando ? `/api/proveedores/${editando._id}` : '/api/proveedores';
      const method = editando ? 'PATCH' : 'POST';
      const res    = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al guardar');

      if (editando) {
        setProveedores(prev => prev.map(p => p._id === editando._id ? { ...p, ...form } : p));
      } else {
        setProveedores(prev => [data, ...prev]);
      }
      setOk(editando ? 'Proveedor actualizado.' : 'Proveedor creado.');
      setTimeout(() => { setOk(''); volver(); }, 1200);
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    try {
      await fetch(`/api/proveedores/${id}`, { method: 'DELETE' });
      setProveedores(prev => prev.filter(p => p._id !== id));
      setConfirmandoEliminar(null);
      if (vista === 'detalle') volver();
    } catch {}
  };

  if (!isOpen) return null;

  return (
    <div className="apv-overlay" onClick={onClose}>
      <div className="apv-panel" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="apv-header">
          <div className="apv-header-left">
            {vista !== 'lista' && (
              <button className="apv-back" onClick={volver}>←</button>
            )}
            <div>
              <h2 className="apv-titulo">
                {vista === 'lista'   && 'Proveedores'}
                {vista === 'form'    && (editando ? 'Editar proveedor' : 'Nuevo proveedor')}
                {vista === 'detalle' && detalle?.nombre}
              </h2>
              <p className="apv-subtitulo">
                {vista === 'lista'   && `${proveedores.length} proveedor${proveedores.length !== 1 ? 'es' : ''}`}
                {vista === 'form'    && (editando ? 'Modificar datos del proveedor' : 'Registrar nuevo proveedor')}
                {vista === 'detalle' && 'Detalle del proveedor'}
              </p>
            </div>
          </div>
          <button className="apv-close" onClick={onClose}>✕</button>
        </div>

        {/* Body */}
        <div className="apv-body">

          {/* ── Lista ── */}
          {vista === 'lista' && (
            <>
              <button className="apv-btn-nuevo" onClick={abrirNuevo}>
                + Nuevo proveedor
              </button>

              {cargando ? (
                <p className="apv-cargando">Cargando…</p>
              ) : proveedores.length === 0 ? (
                <p className="apv-vacio">No hay proveedores registrados.</p>
              ) : (
                <ul className="apv-lista">
                  {proveedores.map(prov => (
                    <li key={prov._id} className="apv-item">
                      <div className="apv-item-info" onClick={() => abrirDetalle(prov)}>
                        <span className="apv-item-nombre">{prov.nombre}</span>
                        <span className="apv-item-meta">
                          {prov.contacto && <span>{prov.contacto}</span>}
                          {prov.telefono && <span>{prov.telefono}</span>}
                        </span>
                        <span className="apv-item-prods">
                          {prov.productos_count} producto{prov.productos_count !== 1 ? 's' : ''}
                        </span>
                      </div>
                      <div className="apv-item-acciones">
                        <button className="apv-btn-editar" onClick={() => abrirEditar(prov)}>✎</button>
                        {confirmandoEliminar === prov._id ? (
                          <div className="apv-confirmar">
                            <span>¿Eliminar?</span>
                            <button className="apv-si" onClick={() => eliminar(prov._id)}>Sí</button>
                            <button className="apv-no" onClick={() => setConfirmandoEliminar(null)}>No</button>
                          </div>
                        ) : (
                          <button className="apv-btn-eliminar" onClick={() => setConfirmandoEliminar(prov._id)}>🗑</button>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </>
          )}

          {/* ── Formulario ── */}
          {vista === 'form' && (
            <div className="apv-form">
              {CAMPOS_FORM.map(campo => (
                <div key={campo.key} className="apv-field">
                  <label>
                    {campo.label}
                    {campo.required && <span className="apv-req"> *</span>}
                  </label>
                  {campo.multiline ? (
                    <textarea
                      name={campo.key}
                      value={form[campo.key]}
                      onChange={handleChange}
                      placeholder={campo.placeholder}
                      rows="3"
                      disabled={guardando}
                    />
                  ) : (
                    <input
                      type={campo.type || 'text'}
                      name={campo.key}
                      value={form[campo.key]}
                      onChange={handleChange}
                      placeholder={campo.placeholder}
                      disabled={guardando}
                    />
                  )}
                </div>
              ))}

              {error && <p className="apv-error">⚠ {error}</p>}
              {ok    && <p className="apv-ok">✓ {ok}</p>}

              <div className="apv-form-footer">
                <button className="apv-btn-cancelar" onClick={volver} disabled={guardando}>
                  Cancelar
                </button>
                <button className="apv-btn-guardar" onClick={guardar} disabled={guardando}>
                  {guardando ? 'Guardando…' : (editando ? 'Guardar cambios' : 'Crear proveedor')}
                </button>
              </div>
            </div>
          )}

          {/* ── Detalle ── */}
          {vista === 'detalle' && detalle && (
            <div className="apv-detalle">
              <div className="apv-detalle-acciones">
                <button className="apv-btn-editar-full" onClick={() => abrirEditar(detalle)}>
                  ✎ Editar proveedor
                </button>
                {confirmandoEliminar === detalle._id ? (
                  <div className="apv-confirmar">
                    <span>¿Eliminar?</span>
                    <button className="apv-si" onClick={() => eliminar(detalle._id)}>Sí</button>
                    <button className="apv-no" onClick={() => setConfirmandoEliminar(null)}>No</button>
                  </div>
                ) : (
                  <button className="apv-btn-eliminar-full" onClick={() => setConfirmandoEliminar(detalle._id)}>
                    🗑 Eliminar
                  </button>
                )}
              </div>

              <div className="apv-detalle-grid">
                {detalle.contacto && (
                  <div className="apv-dato">
                    <span className="apv-dato-label">Contacto</span>
                    <span className="apv-dato-valor">{detalle.contacto}</span>
                  </div>
                )}
                {detalle.telefono && (
                  <div className="apv-dato">
                    <span className="apv-dato-label">Teléfono</span>
                    <a href={`tel:${detalle.telefono}`} className="apv-dato-valor apv-link">{detalle.telefono}</a>
                  </div>
                )}
                {detalle.email && (
                  <div className="apv-dato">
                    <span className="apv-dato-label">Email</span>
                    <a href={`mailto:${detalle.email}`} className="apv-dato-valor apv-link">{detalle.email}</a>
                  </div>
                )}
                {detalle.condiciones_pago && (
                  <div className="apv-dato">
                    <span className="apv-dato-label">Condiciones de pago</span>
                    <span className="apv-dato-valor">{detalle.condiciones_pago}</span>
                  </div>
                )}
                {detalle.notas && (
                  <div className="apv-dato apv-dato-full">
                    <span className="apv-dato-label">Notas</span>
                    <span className="apv-dato-valor">{detalle.notas}</span>
                  </div>
                )}
              </div>

              {/* Productos asociados */}
              <div className="apv-prods-seccion">
                <h3 className="apv-prods-titulo">Productos asociados</h3>
                {cargandoProds ? (
                  <p className="apv-cargando">Cargando…</p>
                ) : productos.length === 0 ? (
                  <p className="apv-vacio">Ningún producto tiene este proveedor asignado.</p>
                ) : (
                  <table className="apv-tabla">
                    <thead>
                      <tr>
                        <th>Producto</th>
                        <th>Stock</th>
                        <th>Costo</th>
                        <th>Precio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productos.map(p => (
                        <tr key={p._id}>
                          <td>{p.nombre}</td>
                          <td className="apv-td-num">{p.stock ?? '—'}</td>
                          <td className="apv-td-num">{p.costo != null ? `$${p.costo.toLocaleString('es-AR')}` : '—'}</td>
                          <td className="apv-td-precio">{p.precio != null ? `$${p.precio.toLocaleString('es-AR')}` : '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
